var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhone = function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.059 11.95-2.798-1.24a.692.692 0 0 0-.7.09l-1.136.796a1.297 1.297 0 0 1-1.137.088 41.103 41.103 0 0 1-3.847-3.982 1.07 1.07 0 0 1 .088-1.15l.787-1.063a.804.804 0 0 0 .087-.796L5.092 1.949a.787.787 0 0 0-.787-.531H3.08A3.016 3.016 0 0 0 1.418 4.25c0 3.186 2.623 6.107 3.847 7.346 1.224 1.239 4.11 3.982 7.432 3.982 0 0 2.098.177 2.798-1.593 0-.088.087-.177.087-.354v-.885a1.149 1.149 0 0 0-.524-.796z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
};
export default SvgIconPhone;